import { render } from "./ChangeCompanyModal.vue?vue&type=template&id=07afbbd7&ts=true"
import script from "./ChangeCompanyModal.vue?vue&type=script&lang=ts"
export * from "./ChangeCompanyModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__